<template>
    <div>
        <div class="MemberAreaContent">
            <div class="MemberAreaContent__left" :class="{'is-open': isFoldersOpen}">
                <company-profile v-if="$user.type === $enums.UserType.COMPANY" @close="isFoldersOpen = false"/>
                <learner-sidebar v-if="$user.type === $enums.UserType.LEARNER" @close="isFoldersOpen = false"/>
            </div>
            <div class="MemberAreaContent__middle MemberAreaContent__middle--full">
                <div class="Chat__head">
                    <button class="Chat__head-contacts" @click.prevent="isFoldersOpen = !isFoldersOpen">
                        <i class="fas fa-user-graduate"></i>
                    </button>
                    <h4 class="Chat__head-title">Formations possibles</h4>
                </div>
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    import FormationIcon from "../icons/FormationIcon";
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import MemberAreaNav from "../MemberAreaNav";
    import FormationsSuggestions from "./FormationsSuggestions";
    import CompanyProfile from "./CompanySidebar";
    import LearnerSidebar from "./LearnerSidebar";

    export default {
        components: {LearnerSidebar, CompanyProfile, FormationsSuggestions, MemberAreaNav, FormationIcon, Multiselect},
        data: function () {
            return {
                isFoldersOpen: false
            }
        }
    }
</script>
